import React, {useContext} from 'react'
import { useFormData, useDependency, useInstanceSaver, useResourceFromPath } from 'hooks'
import {ControlledForm, ErrorBanner, PageContainer, PromiseButton, MeridianBooleanField} from 'components'

import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import { LogBooksContext } from 'contexts'
import {errorStringsFromError} from 'utils'

const Form = () => {
  const {id, action} = useResourceFromPath()
  const logBooks = useContext(LogBooksContext.ReactContext)

  useDependency(() => {
    if(action === 'edit'){
      return logBooks.actions.show(id)
    }
  }, [id, action])

  const [formData, setFormData] = useFormData(logBooks.selected)
  const [save, errors] = useInstanceSaver(formData, logBooks, action)

  return (
    <PageContainer>
      <Typography variant='h5'>{action === 'edit' ? `Edit Log Book` : 'Create a new Log Book'}</Typography>
      <ControlledForm data={formData} errors={errors} onChange={setFormData} onSubmit={save}>
        <ErrorBanner>{errorStringsFromError(logBooks.actions.apiErrorsFor('create', 'update'))}</ErrorBanner>
        <TextField fullWidth name='title'/>
        <TextField fullWidth name='updateInterval' type="number" label="Update Interval (minutes)"/>
        <MeridianBooleanField fullWidth name='activeFlag' label="Is Active?" />
      <PromiseButton color='secondary' fullWidth variant='contained' type='submit'>Save</PromiseButton>
      </ControlledForm>
    </PageContainer>
  )
}

export default (props) => (
  <LogBooksContext>
    <Form {...props} />
  </LogBooksContext>
)